import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["value", "valuetext", "definition"];
  connect() {
    console.log("Hello, NON GRS");
    this.checkIfComplete();
    this.addKeyboardListeners();
    this.showInitialDefinition();
  }

  showInitialDefinition() {
    // Show definition for initially selected value if any
    const activeButton = this.element.querySelector(
      ".grs-value-active, .grs-value-text-active, .grs-value-text-multiline-active"
    );
    if (activeButton) {
      const valueElement = activeButton.querySelector(".grs-value-main");
      const selectedValue = valueElement
        ? valueElement.textContent.trim()
        : activeButton.textContent.trim();
      this.showDefinition(selectedValue);
    }
  }

  showDefinition(selectedValue) {
    const definitionsCount = parseInt(this.element.dataset.count);
    if (!definitionsCount) return;

    let definition = "";

    // Find the definition for the selected value
    for (let i = 0; i < definitionsCount; i++) {
      const value = this.element.dataset[`val${i}`];
      if (value === selectedValue) {
        definition = this.element.dataset[`def${i}`] || "";
        break;
      }
    }

    // Get the definition element
    const definitionElement =
      this.definitionTarget ||
      this.element.querySelector(".grs-definition-display");

    if (definitionElement) {
      if (definition && definition.trim() !== "") {
        definitionElement.textContent = definition;
        definitionElement.style.display = "block";
      } else {
        definitionElement.style.display = "none";
      }
    }
  }

  addKeyboardListeners() {
    // Add keyboard event listeners to all rating buttons
    const buttons = this.element.querySelectorAll(
      ".grs-select, .grs-select-text, .grs-select-inline, .grs-select-text-inline"
    );
    buttons.forEach((button) => {
      button.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          button.click();
        }
      });
    });
  }

  valueChange(e) {
    console.log("VALUE CHANGE", e.target);
    let buttons = this.element.getElementsByClassName("grs-select");
    let text_buttons = this.element.getElementsByClassName("grs-select-text");

    // Get the value from the clicked element or its parent
    let clickedButton =
      e.target.closest(".grs-select") || e.target.closest(".grs-select-text");
    let valueElement = clickedButton.querySelector(".grs-value-main");
    let new_value = valueElement
      ? valueElement.textContent.trim()
      : e.target.textContent.trim();

    if (
      e.target.dataset.type === "number" ||
      clickedButton.dataset.type === "number"
    ) {
      console.log("NUMBER CHANGE");
      this.valueTarget.value = new_value;
      this.valuetextTarget.value = null;
    } else if (
      e.target.dataset.type === "text" ||
      clickedButton.dataset.type === "text"
    ) {
      console.log("TEXT CHANGE");
      this.valuetextTarget.value = new_value;
      this.valueTarget.value = null;
    }

    // Show the definition for the selected value
    this.showDefinition(new_value);

    for (let i = 0; i < buttons.length; i++) {
      let button = buttons[i];
      let buttonValue = button.querySelector(".grs-value-main");
      let buttonValueText = buttonValue
        ? buttonValue.textContent.trim()
        : button.textContent.trim();
      const isActive = buttonValueText === new_value;
      button.className = isActive
        ? "grs-select grs-value-active"
        : "grs-select grs-value";
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    }
    for (let i = 0; i < text_buttons.length; i++) {
      let button = text_buttons[i];
      let buttonValue = button.querySelector(".grs-value-main");
      let buttonValueText = buttonValue
        ? buttonValue.textContent.trim()
        : button.textContent.trim();
      const isActive = buttonValueText === new_value;
      button.className = isActive
        ? "grs-select-text grs-value-text-active"
        : "grs-select-text grs-value";
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    }
    this.checkIfComplete();
  }
  multilineValueChange(e) {
    let buttons = this.element.getElementsByClassName("grs-select");
    let text_buttons = this.element.getElementsByClassName("grs-select-text");
    let inline_buttons =
      this.element.getElementsByClassName("grs-select-inline");
    let inline_text_buttons = this.element.getElementsByClassName(
      "grs-select-text-inline"
    );

    // Get the value from the clicked element or its parent
    let clickedButton =
      e.target.closest(".grs-select") ||
      e.target.closest(".grs-select-text") ||
      e.target.closest(".grs-select-inline") ||
      e.target.closest(".grs-select-text-inline");

    let valueElement = clickedButton.querySelector(".grs-value-main");
    let new_value = valueElement
      ? valueElement.textContent.trim()
      : e.target.textContent.trim();

    if (
      e.target.dataset.type === "number" ||
      clickedButton.dataset.type === "number"
    ) {
      this.valueTarget.value = new_value;
      this.valuetextTarget.value = "";
    } else if (
      e.target.dataset.type === "text" ||
      clickedButton.dataset.type === "text"
    ) {
      this.valuetextTarget.value = new_value;
      this.valueTarget.value = null;
    }

    // Show the definition for the selected value
    this.showDefinition(new_value);

    // Update regular buttons (for multiple_below view)
    for (let i = 0; i < buttons.length; i++) {
      let button = buttons[i];
      let buttonValue = button.querySelector(".grs-value-main");
      let buttonValueText = buttonValue
        ? buttonValue.textContent.trim()
        : button.textContent.trim();
      const isActive = buttonValueText === new_value;
      button.className = isActive
        ? "grs-select grs-value-active"
        : "grs-select grs-value-multi-inline";
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    }
    for (let i = 0; i < text_buttons.length; i++) {
      let button = text_buttons[i];
      let buttonValue = button.querySelector(".grs-value-main");
      let buttonValueText = buttonValue
        ? buttonValue.textContent.trim()
        : button.textContent.trim();
      const isActive = buttonValueText === new_value;
      button.className = isActive
        ? "grs-select-text grs-value-text-multiline-active"
        : "grs-select-text grs-value-multi-inline";
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    }

    // Update inline buttons (for multiple_inline view)
    for (let i = 0; i < inline_buttons.length; i++) {
      let button = inline_buttons[i];
      let buttonValue = button.querySelector(".grs-value-main");
      let buttonValueText = buttonValue
        ? buttonValue.textContent.trim()
        : button.textContent.trim();
      const isActive = buttonValueText === new_value;
      button.className = isActive
        ? "grs-select-inline grs-value-active"
        : "grs-select-inline grs-value-multi-inline";
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    }
    for (let i = 0; i < inline_text_buttons.length; i++) {
      let button = inline_text_buttons[i];
      let buttonValue = button.querySelector(".grs-value-main");
      let buttonValueText = buttonValue
        ? buttonValue.textContent.trim()
        : button.textContent.trim();
      const isActive = buttonValueText === new_value;
      button.className = isActive
        ? "grs-select-text-inline grs-value-text-multiline-active"
        : "grs-select-text-inline grs-value-multi-inline";
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    }

    this.checkIfComplete();
  }
  checkboxValueChange(e) {
    let value = this.element.dataset.scorevalue;
    let text = this.element.dataset.scoretext;
    let current = this.valueTarget.value
      ? this.valueTarget.value
      : this.valuetextTarget.value;
    if (current) {
      this.valueTarget.value = null;
      this.valuetextTarget.value = null;
      let new_el = document.createElement("div");
      new_el.className = "non-grs-checked-checkbox";
      new_el.setAttribute(
        "data-action",
        "click->non-grs-edit#checkboxValueChange"
      );
      e.target.replaceWith(new_el);
    } else if (value) {
      this.valueTarget.value = value;
      let new_el = document.createElement("i");
      new_el.className = "fa fa-check non-grs-checked-checkbox";
      new_el.setAttribute(
        "data-action",
        "click->non-grs-edit#checkboxValueChange"
      );
      e.target.replaceWith(new_el);
    } else if (text) {
      this.valuetextTarget.value = text;
      let new_el = document.createElement("i");
      new_el.className = "fa fa-check non-grs-checked-checkbox";
      new_el.setAttribute(
        "data-action",
        "click->non-grs-edit#checkboxValueChange"
      );
      e.target.replaceWith(new_el);
    }
    this.checkIfComplete();
    console.log("CURRENT", current);
    console.log("VALUE", value);
    console.log("TEXT", text);
    console.log("CLICKED", e.target);
  }

  checkIfComplete() {
    let complete = true;
    let items = document.getElementsByClassName("non-grs-section-items");
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      const inputsWithDataTarget = item.querySelectorAll("input[data-target]");
      let has_value = false;
      for (let i = 0; i < inputsWithDataTarget.length; i++) {
        const input = inputsWithDataTarget[i];
        if (input.value) {
          has_value = true;
        } else {
        }
      }
      let question_info =
        item.getElementsByClassName("question-info")[0].innerText;
      let mandatory = question_info.includes("Mandatory");

      if (mandatory && !has_value) {
        complete = false;
      }
    }
    let submit_button = document.getElementById("form-submit");
    if (submit_button) {
      submit_button.disabled = !complete;
    }
    let mandatory_message = document.getElementById("mandatory-text");
    if (!complete && mandatory_message) {
      mandatory_message.style.display = "block";
    } else if (mandatory_message) {
      mandatory_message.style.display = "none";
    }

    console.log("COMPLETE", complete);
  }
}
